import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../Auth';
import { useAxios } from '../AxiosHandler';

interface PageTableParams {
  dataUrl: string;
  currentPageNumber: number;
  pageSize: number;
  sortField?: string;
  sortDirection?: string;
  selectedCols: string[];
  filters: any[];
  permaFilters?: any[];
  exclusiveFilters?: any[];
  additionalData?: any;
  data?: any;
  enabled?: boolean;
}

interface PageTableResponse {
  pagedata: any[];
  pagestotal: number;
  totalcount: number;
}

export function usePageTableData(params: PageTableParams) {
  const auth = useAuth();
  const axiosHandler = useAxios();
  const axios = axiosHandler.axios;

  const {
    dataUrl,
    currentPageNumber,
    pageSize,
    sortField,
    sortDirection,
    selectedCols,
    filters,
    permaFilters = [],
    exclusiveFilters = [],
    additionalData = {},
    data = {},
    enabled = true,
  } = params;

  // Build query key from all parameters that affect the result
  const queryKey = [
    'pageTable',
    dataUrl,
    currentPageNumber,
    pageSize,
    sortField,
    sortDirection,
    selectedCols,
    filters,
    permaFilters,
    exclusiveFilters,
    additionalData,
    data,
    auth.selectedCountry || 'all',
    auth.selectedBreed,
  ];

  return useQuery<PageTableResponse>({
    queryKey,
    queryFn: async () => {
      const res = await axios.single({
        method: 'post',
        url: dataUrl,
        responseType: 'json',
        data: {
          ...data,
          pagenumber: currentPageNumber,
          pagesize: pageSize,
          sorting: { 
            field: selectedCols.includes(sortField || '') ? sortField : undefined, 
            order: selectedCols.includes(sortField || '') ? sortDirection : undefined 
          },
          exclusiveFilters: exclusiveFilters,
          additionalData: additionalData,
          filters: filters.filter((filter: any) => selectedCols.includes(filter.field)),
          selectedCols: selectedCols,
        },
        headers: { 
          'x-access-token': auth.user['token'], 
          'selected-country': auth.selectedCountry || 'all' 
        }
      });

      return res.data;
    },
    enabled,
    staleTime: 30000, // Consider data fresh for 30 seconds
    gcTime: 5 * 60 * 1000, // Keep unused data in cache for 5 minutes
  });
}
